<template>
  <div>
    <h3 class="py-4 fw-600">
      <b-skeleton-img no-aspect height="30px" width="40%" />
    </h3>

    <b-table-simple responsive class="disclosure-table lg border-bottom mb-5">
      <b-thead>
        <b-tr>
          <b-td style="min-width: 22%; width: 32%" />
          <b-td class="d-lg-flex justify-content-between">
            <div class="f-90">
              <b-icon icon="table" class="mr-1" />
              <b-icon icon="file-earmark-text" class="ml-3 mr-1" />
              <b-icon icon="link-45deg" class="ml-3 mr-1" />
              <b-icon icon="briefcase" class="ml-3 mr-1" />
            </div>
          </b-td>
        </b-tr>
      </b-thead>

      <b-tbody class="mb-2 border-0">
        <b-tr>
          <b-td colspan="2" class="py-1 pl-1">
            <span class="fw-500 f-120">
              <b-skeleton animation="wave" width="20%" />
            </span>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td class="pr-4 d-flex flex-column">
            <div class="fw-500">
              <b-skeleton animation="wave" width="30%" />
              <b-skeleton animation="wave" width="15%" />
            </div>
          </b-td>
          <b-td class="" style="max-width: 200mm">
            <b-skeleton animation="wave" width="85%" />
            <b-skeleton animation="wave" width="55%" />
            <b-skeleton animation="wave" width="70%" />
          </b-td>
        </b-tr>
        <b-tr>
          <b-td class="pr-4 d-flex flex-column">
            <div class="fw-500">
              <b-skeleton animation="wave" width="30%" />
              <b-skeleton animation="wave" width="15%" />
            </div>
          </b-td>
          <b-td class="" style="max-width: 200mm">
            <b-skeleton animation="wave" width="55%" />
            <b-skeleton animation="wave" width="35%" />
            <b-skeleton animation="wave" width="70%" />
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
